export const DEFAULT_RICH_HTML =
  "<p>Escribe aquí el mensaje para tus suscriptores. Puedes formatear texto como en un documento de Word.</p>";

export const DEFAULT_EMAIL_HTML = `<table width="100%" cellpadding="0" cellspacing="0" style="background:#eef2f7;padding:28px 12px;font-family:Inter,Arial,Helvetica,sans-serif;">
  <tbody>
    <tr>
      <td align="center">
        <table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;background:#ffffff;border-radius:14px;overflow:hidden;box-shadow:0 12px 40px rgba(15,23,42,0.08);">
          <tbody>
            <tr>
              <td style="height:5px;background:linear-gradient(90deg,#2563eb,#3b82f6);padding:0;line-height:0;font-size:0;">&nbsp;</td>
            </tr>
            <tr>
              <td style="padding:36px 32px 12px;font-size:28px;line-height:1.25;font-weight:700;color:#0f172a;">
                Título de tu campaña
              </td>
            </tr>
            <tr>
              <td style="padding:8px 32px 20px;font-size:16px;line-height:1.65;color:#475569;">
                Escribe aquí el mensaje para tus suscriptores. Arrastra bloques desde el panel izquierdo o genera contenido con IA.
              </td>
            </tr>
            <tr>
              <td style="padding:8px 32px 32px;text-align:center;">
                <a href="https://wembii.com" style="display:inline-block;padding:13px 28px;border-radius:10px;background:#2563eb;color:#ffffff;text-decoration:none;font-weight:700;font-size:15px;">
                  Ver más
                </a>
              </td>
            </tr>
            <tr>
              <td style="padding:20px 32px 28px;border-top:1px solid #e2e8f0;font-size:12px;line-height:1.5;color:#94a3b8;text-align:center;">
                Enviado con Wembii · Tu empresa
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>`;

const escapeHtml = (value: string) =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

export interface EmailAiTemplate {
  subject?: string;
  body: string;
  callToAction?: string;
  title?: string;
}

export const wrapRichHtmlForEmail = (html: string) => {
  const body = html?.trim() || DEFAULT_RICH_HTML;
  return `<div style="max-width:600px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;font-size:16px;line-height:1.6;color:#334155;">${body}</div>`;
};

export const aiEmailToHtml = (body: string, callToAction?: string): string => {
  const lines = body
    .split(/\n{2,}|\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const textRows = lines
    .map(
      (line) =>
        `<tr><td style="padding: 0 0 16px; font-size: 16px; line-height: 1.6; color: #334155;">${escapeHtml(
          line
        )}</td></tr>`
    )
    .join("");

  const ctaRow = callToAction
    ? `<tr><td style="padding: 16px 0; text-align: center;">
      <a href="https://wembii.com" style="display: inline-block; padding: 12px 24px; border-radius: 8px; background: #2563eb; color: #ffffff; text-decoration: none; font-weight: 700;">${escapeHtml(
        callToAction
      )}</a>
    </td></tr>`
    : "";

  return `<table width="100%" cellpadding="0" cellspacing="0" style="max-width: 600px; margin: 0 auto; font-family: Arial, Helvetica, sans-serif; color: #1e293b;">
  <tbody>
    ${textRows}
    ${ctaRow}
  </tbody>
</table>`;
};

export const isEmptyEmailHtml = (html: string) => {
  const stripped = html.replace(/<[^>]*>/g, "").trim();
  return !stripped;
};
